import { cn } from '@util/index';
import Link from 'next/link';
import { CheckmarkIcon } from '..';
interface Props {
  checked?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  label: string;
  className?: string;
  textLeft?: boolean;
  link?: string;
}
const CheckmarkIconButton = ({
  checked,
  disabled = false,
  onClick,
  label,
  className,
  textLeft = false,
  link,
}: Props) => {
  return (
    <div
      className={cn(
        `flex w-fit cursor-pointer items-center`,
        textLeft && 'flex-row-reverse gap-x-2',
        className
      )}
      onClick={onClick}
    >
      <button
        aria-label={label}
        disabled={disabled}
        className={cn(
          'flex min-h-[2.5rem] min-w-[2.5rem] items-center justify-center rounded-[.5rem] transition-all duration-200 ease-in-out sm:min-h-[1.6rem] sm:min-w-[1.6rem]',
          checked
            ? 'scale-[1.05] bg-brand-secondary'
            : 'scale-100 border border-brand-dark-gray',
          className
        )}
        type="button"
      >
        <div
          className={cn(
            '-mr-[0.4px] mt-[0.3px] flex w-full items-center justify-center transition-opacity duration-200',
            checked ? 'opacity-100' : 'opacity-0'
          )}
        >
          <CheckmarkIcon height={6} width={10} variant="white" />
        </div>
      </button>

      {link && label ? (
        <Link
          tabIndex={-1}
          aria-hidden="true"
          href={link}
          className="ml-4 select-none text-body-md font-medium !text-black"
        >
          {label}
        </Link>
      ) : (
        label && (
          <div className="ml-4 select-none text-body-md font-medium !text-black">
            {label}
          </div>
        )
      )}
    </div>
  );
};

export default CheckmarkIconButton;
